// Auto-generated index of Bard components
import Bard_Brainstorming from "./bard_components/Bard_General/Bard_Brainstorming.jsx";
import Bard_Cover_Letter from "./bard_components/Bard_General/Bard_Cover_Letter.jsx";
import Bard_Email from "./bard_components/Bard_General/Bard_Email.jsx";
import Bard_Explain from "./bard_components/Bard_General/Bard_Explain.jsx";
import Bard_Find_Title from "./bard_components/Bard_General/Bard_Find_Title.jsx";
import Bard_First_Draft from "./bard_components/Bard_General/Bard_First_Draft.jsx";
import Bard_Resume from "./bard_components/Bard_General/Bard_Resume.jsx";
import Bard_Summarize from "./bard_components/Bard_General/Bard_Summarize.jsx";

import Bard_SoMe_Facebook from "./bard_components/Bard_Social_Media/Bard_SoMe_Facebook.jsx";
import Bard_SoMe_LinkedIn from "./bard_components/Bard_Social_Media/Bard_SoMe_LinkedIn.jsx";
import Bard_SoMe_Twitter from "./bard_components/Bard_Social_Media/Bard_SoMe_Twitter.jsx";

import Bard_Few_Shot from "./bard_components/Bard_Tutorial/Bard_Few_Shot.jsx";
import Bard_Get_Started from "./bard_components/Bard_Tutorial/Bard_Get_Started.jsx";
import Bard_Home from "./bard_components/Bard_Tutorial/Bard_Home.jsx";
import Bard_Intro from "./bard_components/Bard_Tutorial/Bard_Intro.jsx";
import Bard_Roles from "./bard_components/Bard_Tutorial/Bard_Roles.jsx";

const bardComponentsMap = {
  "<Bard_Brainstorming />": Bard_Brainstorming,
  "<Bard_Cover_Letter />": Bard_Cover_Letter,
  "<Bard_Email />": Bard_Email,
  "<Bard_Explain />": Bard_Explain,
  "<Bard_Find_Title />": Bard_Find_Title,
  "<Bard_First_Draft />": Bard_First_Draft,
  "<Bard_Resume />": Bard_Resume,
  "<Bard_Summarize />": Bard_Summarize,

  "<Bard_SoMe_Facebook />": Bard_SoMe_Facebook,
  "<Bard_SoMe_LinkedIn />": Bard_SoMe_LinkedIn,
  "<Bard_SoMe_Twitter />": Bard_SoMe_Twitter,

  "<Bard_Few_Shot />": Bard_Few_Shot,
  "<Bard_Get_Started />": Bard_Get_Started,
  "<Bard_Home />": Bard_Home,
  "<Bard_Intro />": Bard_Intro,
  "<Bard_Roles />": Bard_Roles,
};

export default bardComponentsMap;
